// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"f53ccef9","121":"b593338c","130":"2a353631","146":"77a3866a","415":"9d825fab","728":"04c14b4a"}[chunkId] + ".chunk.js";
};